import { useMemo as e, useState as t } from "/home/runner/work/oko-web/oko-web/node_modules/react/index.js";
//#region src/lib/hooks/useFormField.ts
function n(n, r) {
	let [i, a] = t(n.defaultValue), [o, s] = t(!1), [c, l] = t(!1), u = e(() => n.validators ? Object.fromEntries(Object.entries(n.validators).map(([e, t]) => [e, !t(i)])) : {}, [i, ...r ?? []]);
	return {
		value: i,
		setValue: (e) => {
			e !== n.defaultValue && l(!0), a(e);
		},
		errors: u,
		isDirty: c,
		isTouched: o,
		setIsTouched: () => s(!0),
		isValid: e(() => !u || Object.values(u).every((e) => !e), [u]),
		resetIsTouched: () => s(!1),
		resetIsDirty: () => l(!1)
	};
}
//#endregion
export { n as useFormField };
